import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpHeaders, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class commonInterceptor implements HttpInterceptor {
    intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let currentUser  = JSON.parse(localStorage.getItem('currentUser'));
        if(currentUser != null && currentUser != 0   ){    
            let usermasterid = currentUser.user_master_id;
            let utoken       = currentUser.utoken; 
            let roletype     = "super";
            const commonReq = req.clone({
                headers: req.headers.set('utoken',atob(utoken)).set('loginuserid',atob(usermasterid)).set("roletype",roletype).set("usertype","S").set("apptype","W")
            });
            return next.handle(commonReq);
        }else{
            return next.handle(req);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/interceptors/common-interceptors.ts